/** Business Card — document knowledge definition. Pure data. */
export default {
  id: 'business-card',
  name: 'Business Card',
  description: 'A pocket-sized identity card carrying a person’s essential contact details.',
  purpose: 'Personal & Professional Identity',
  recommendedSizes: [
    { name: 'Standard (3.5×2 in)', width: 1050, height: 600, unit: 'px' },
    { name: 'Standard Portrait', width: 600, height: 1050, unit: 'px' },
  ],
  supportedOrientations: ['landscape', 'portrait'],
  supportsMultiplePages: true,
  supportsBleed: true,
  supportsImages: false,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: false,
  supportsOffers: false,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Logo', 'Name', 'Title', 'Phone', 'Email', 'Website', 'QR'],
};
